/* eslint-disable camelcase */
import 'src/styles/ui/run-user-status.css';

import { faUserCheck, faUserXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDateLocale } from 'src/hooks/useDateLocale';
import { RUN_STATUS } from 'src/utils/constants';

const RunUserStatus = ({ runStatus, runUser, latestAttendingTimeEntry }) => {
  const { formattedDateTime } = useDateLocale();
  const { start_time, end_time } = latestAttendingTimeEntry ?? {};

  const isPaused = runStatus === RUN_STATUS.paused;
  const isValidEndTime = end_time && dayjs(end_time).isValid();

  const runActivityLabel = isPaused
    ? 'Inactive'
    : runStatus === RUN_STATUS.inProgress
      ? 'Active'
      : null;

  const runUserActiveLabel =
    !isValidEndTime
      ? 'Attended'
      : 'Unattended'

  const runUserTooltip = isValidEndTime
    ? `Last attended by ${runUser} at`
    : `Attended by ${runUser} since`;

  if (!latestAttendingTimeEntry) return null;

  return (
    <div className={clsx('run-user-status', {
      'run-user-status--active': !isValidEndTime,
    })}
    >
      <div className="run-user-status__label">
        <span>{runActivityLabel}</span>
        <span className="run-user-status__dot" />
        <span>{runUserActiveLabel}</span>
      </div>
      <OverlayTrigger
        placement="bottom"
        overlay={(
          <Tooltip>
            {runUserTooltip}{' '}
            {formattedDateTime(isValidEndTime ? end_time : start_time)}
          </Tooltip>
        )}
      >
        <FontAwesomeIcon
          className="run-user-status__icon"
          icon={!isValidEndTime ? faUserCheck : faUserXmark}
          onClick={(event) => event.stopPropagation()}
        />
      </OverlayTrigger>
    </div>
  );
}

RunUserStatus.propTypes = {
  runStatus: PropTypes.string.isRequired,
  runUser: PropTypes.string,
  latestAttendingTimeEntry: PropTypes.shape({
    start_time: PropTypes.string,
    end_time: PropTypes.string,
  }),
};

export default RunUserStatus;
